import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListComponent } from './list/list.component';
import { AddComponent } from './add/add.component';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';

const routes: Routes = [
  {
    path: 'list', component:ListComponent,
    
    canActivate: [PermissionGuard],
    data: { roles: ['admin','Managment','HR','Training Moderator'] } 
  },
  {
    path: 'add', component:AddComponent
  },
  {
    path: 'edit/:id', component:AddComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OpeningRoutingModule { }
